import Box from '@material-ui/core/Box'
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import Popover from '@material-ui/core/Popover'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Typography from '../base/Typography'
import Icon from '../icons/Icons'

export type CardPopoverProps = {
  direction?: 'row' | 'column'
  data: {
    label: string
    onPress(): void
  }[]
} & IconButtonProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
      display: 'grid',
      gridGap: theme.spacing(2)
    },
    link: {
      color: theme.palette.common.black,
      cursor: 'pointer'
    },
    iconRow: {
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      color: theme.palette.grey[700]
    },
    iconColumn: {
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      color: theme.palette.grey[700],
      transform: 'rotate(-90deg)',
      transformOrigin: '100% 50%'
    }
  })
)

const PayrollCard: React.FC<CardPopoverProps> = (props) => {
  const { data, direction } = props
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  return (
    <Box>
      <IconButton
        classes={
          direction === 'column'
            ? { root: classes.iconColumn }
            : { root: classes.iconRow }
        }
        color="primary"
        component="small"
        onClick={handleClick}
        {...props}
      >
        <Icon iconName="OptionsIcon" size="medium" />
      </IconButton>
      <Popover
        classes={{ paper: classes.popover }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        elevation={3}
      >
        {data.map((item) => (
          <Typography key={item.label} variant="body2">
            <Link
              classes={{ root: classes.link }}
              onClick={() => {
                item.onPress()
                handleClose()
              }}
            >
              {item.label}
            </Link>
          </Typography>
        ))}
      </Popover>
    </Box>
  )
}

export default PayrollCard
